import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReferenceListPage from "../components/ReferenceListPage";
import { communicationMethodsAPI } from "../services/api";
import { loadCommunicationMethods } from "../store/slices/referenceDataSlice";
import { PERMISSIONS } from "../utils/permissions";
import {
  COMMUNICATION_METHOD_ICON_CODES,
  DEFAULT_COMMUNICATION_METHOD_ICON,
  DEFAULT_ULTRAMSG_GROUP_ID,
  getCommunicationMethodIcon,
} from "../utils/communicationMethodIcons";

const CommunicationMethodsPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <ReferenceListPage
      title={t("sidebar.communicationMethods")}
      api={communicationMethodsAPI}
      reloadThunk={loadCommunicationMethods}
      requiredPermission={PERMISSIONS.MANAGE_COMMUNICATION_METHODS}
      onNavigate={onNavigate}
      columns={[
        { field: "method_id", label: "#" },
        { field: "name_en", label: t("referencePages.nameEn") },
        { field: "name_ar", label: t("referencePages.nameAr") },
        {
          field: "send_whatsapp",
          label: t("referencePages.sendWhatsapp"),
          render: (item) =>
            item.send_whatsapp
              ? t("referencePages.yes")
              : t("referencePages.no"),
        },
        {
          field: "ultramsg_group_id",
          label: t("referencePages.ultramsgGroupId"),
        },
        {
          field: "icon_code",
          label: t("referencePages.iconCode"),
          render: (item) => {
            const IconComponent = getCommunicationMethodIcon(item.icon_code);
            return (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconComponent fontSize="small" color="primary" />
                <span>{item.icon_code || DEFAULT_COMMUNICATION_METHOD_ICON}</span>
              </Box>
            );
          },
        },
      ]}
      formFields={[
        {
          name: "name_en",
          label: t("referencePages.nameEn"),
          required: true,
        },
        {
          name: "name_ar",
          label: t("referencePages.nameAr"),
          required: true,
        },
        {
          name: "send_whatsapp",
          label: t("referencePages.sendWhatsapp"),
          type: "boolean",
          defaultValue: false,
        },
        {
          name: "ultramsg_group_id",
          label: t("referencePages.ultramsgGroupId"),
          defaultValue: DEFAULT_ULTRAMSG_GROUP_ID,
          required: true,
        },
        {
          name: "icon_code",
          label: t("referencePages.iconCode"),
          type: "icon-select",
          options: COMMUNICATION_METHOD_ICON_CODES,
          defaultValue: DEFAULT_COMMUNICATION_METHOD_ICON,
          required: true,
        },
      ]}
    />
  );
};

export default CommunicationMethodsPage;
